<template>
  <b-list-group :key="keys.OptionsList">
    <b-list-group-item
      v-if="type === 'hostess'"
      class="d-flex flex-column flex-nowrap align-items-center justify-content-between px-2"
      :class="msgCostClass"
    >
      <div
        class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2 w-100"
      >
        <div
          v-shtml="
            $t('fCustomer_opt_msgCost', {
              value: characterFreeChat
                ? $t('fCustomer_opt_msgCostFreeChatMsg')
                : '',
            })
          "
          class="small text-nowrap"
        />
        <b-input-group style="width: 100px">
          <b-form-input
            ref="characterMsgCost"
            v-model="characterMsgCost"
            type="text"
            size="sm"
            class="text-right"
            style="width: 100px"
            :disabled="isLocked || characterMsgCostLocked"
            :min="3"
            @input="onChange('characterMsgCost')"
          />
        </b-input-group>
      </div>
      <div
        v-if="
          (parseInt(characterMsgCost, 10) < 3 || characterMsgCost === '') &&
            isDirty('characterMsgCost')
        "
        class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2 mt-2 w-100"
      >
        <div class="small text-nowrap text-danger">
          <font-awesome-icon :icon="['fas', 'triangle-exclamation']" />
          {{ $t("fCustomer_opt_msgTmpCostZeroCostError") }}
        </div>
      </div>
    </b-list-group-item>
    <b-list-group-item
      v-if="type === 'hostess'"
      class="d-flex flex-column flex-nowrap align-items-center justify-content-between px-2"
    >
      <div
        class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2 w-100"
      >
        <div
          v-shtml="$t('fCustomer_opt_stopp_loss')"
          class="small text-nowrap"
        />
        <b-input-group style="width: 100px">
          <b-form-input
            ref="characterStopLoss"
            v-model="characterStopLoss"
            type="text"
            size="sm"
            class="text-right"
            style="width: 100px"
            :disabled="isLocked || status === 'inactive'"
            @input="onChange('characterStopLoss')"
          />
          <small v-if="characterStopLoss === 0" class="text-muted">
            default 9
          </small>
        </b-input-group>
      </div>
    </b-list-group-item>

    <b-list-group-item
      v-if="type === 'hostess'"
      class="d-flex flex-column flex-nowrap align-items-center justify-content-between px-2"
    >
      <div
        class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2 w-100"
      >
        <div
          v-shtml="$t('fCustomer_opt_stopp_gain')"
          class="small text-nowrap"
        />
        <b-input-group style="width: 100px">
          <b-form-input
            ref="characterStopGain"
            v-model="characterStopGain"
            type="text"
            size="sm"
            class="text-right"
            style="width: 100px"
            :disabled="isLocked || status === 'inactive'"
            @input="onChange('characterStopGain')"
          />
          <small v-if="characterStopGain === 0" class="text-muted">
            default 39
          </small>
        </b-input-group>
      </div>
    </b-list-group-item>
    <b-list-group-item
      v-if="type === 'hostess'"
      class="d-flex flex-column flex-nowrap align-items-center justify-content-between px-2"
    >
      <div
        class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2 w-100"
      >
        <div
          v-shtml="$t('fCustomer_opt_actual_cost')"
          class="small text-nowrap"
        />
        <div v-if="characterMsgCostLocked">
          {{ parseInt(characterMsgCostLockedValue, 10) || 0 }}
          <font-awesome-icon
            :icon="['fas', 'lock']"
            class="ml-1 text-muted"
            :title="$t('fCustomer_opt_msgCostLocked')"
          />
        </div>
        <div v-else>
          {{
            parseInt(characterMsgCost, 10) + parseInt(characterCostModifier, 10)
          }}
          <span
            v-if="characterCostModifier !== 0"
            :class="characterCostModifier > 0 ? 'text-success' : 'text-danger'"
          >({{ characterCostModifier }})</span>
        </div>
      </div>
    </b-list-group-item>

    <!-- ID-62: blocco manuale del costo hostess -->
    <b-list-group-item
      v-if="type === 'hostess'"
      class="d-flex flex-column flex-nowrap align-items-center justify-content-between px-2"
      :class="characterMsgCostLockedClass"
    >
      <div
        class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2 w-100"
      >
        <div class="small text-nowrap">
          {{ $t('fCustomer_opt_msgCostLocked') }}:
        </div>
        <div class="d-flex flex-row flex-nowrap align-items-center">
          <b-form-input
            ref="characterMsgCostLockedValue"
            v-model="characterMsgCostLockedValue"
            type="text"
            size="sm"
            class="text-right mr-2"
            style="width: 70px"
            :min="3"
            :disabled="isLocked || !characterMsgCostLocked"
            :title="$t('fCustomer_opt_msgCostLockedValue')"
            @input="onChange('characterMsgCostLockedValue')"
          />
          <b-form-checkbox
            v-model="characterMsgCostLocked"
            size="sm"
            switch
            :disabled="isLocked"
            @input="onChange('characterMsgCostLocked')"
          />
        </div>
      </div>
      <div
        v-if="
          characterMsgCostLocked &&
            (parseInt(characterMsgCostLockedValue, 10) < 3 ||
              characterMsgCostLockedValue === '')
        "
        class="d-flex flex-row flex-nowrap align-items-center justify-content-start px-2 mt-2 w-100"
      >
        <div class="small text-nowrap text-danger">
          <font-awesome-icon :icon="['fas', 'triangle-exclamation']" />
          {{ $t("fCustomer_opt_msgTmpCostZeroCostError") }}
        </div>
      </div>
      <div
        v-if="msgCostLockInfo.locked"
        class="d-flex flex-row flex-nowrap align-items-center justify-content-start px-2 mt-1 w-100"
      >
        <div class="small text-muted">
          <font-awesome-icon :icon="['fas', 'lock']" class="mr-1" />
          {{
            $t('fCustomer_opt_msgCostLockedAt', {
              date: msgCostLockInfo.at,
              cost: msgCostLockInfo.cost
            })
          }}
          <template v-if="msgCostLockInfo.by && msgCostLockInfo.by.email">
            &mdash; {{ msgCostLockInfo.by.email }}
          </template>
        </div>
      </div>
      <div
        v-if="msgCostLockInfo.locked && msgCostLockInfo.restoreCost !== null"
        class="d-flex flex-row flex-nowrap align-items-center justify-content-start px-2 w-100"
      >
        <div class="small text-muted">
          {{
            $t('fCustomer_opt_msgCostLockedRestore', {
              cost: msgCostLockInfo.restoreCost
            })
          }}
        </div>
      </div>
    </b-list-group-item>

    <!-- ID-637: START SCORE (editorial visibility gate) -->
    <b-list-group-item
      v-if="type === 'hostess'"
      class="d-flex flex-column flex-nowrap align-items-center justify-content-between px-2"
      :class="startScoreClass"
    >
      <div
        class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2 w-100"
      >
        <div class="small text-nowrap">
          {{ $t('fCustomer_opt_startScore') }}:
        </div>
        <b-form-select
          ref="startScore"
          v-model="startScore"
          size="sm"
          style="width: 120px"
          :options="startScoreOptions"
          :disabled="isLocked"
          @input="onChange('startScore')"
        />
      </div>
      <!-- ID-637: score EFFETTIVO calcolato a runtime (R(now)), non persistito -->
      <div
        v-if="info.start_score && ((info.start_score.current !== null && info.start_score.current !== undefined) || info.start_score.at)"
        class="d-flex flex-row flex-nowrap align-items-center justify-content-start px-2 mt-1 w-100"
      >
        <b-badge
          v-if="info.start_score.current !== null && info.start_score.current !== undefined"
          variant="danger"
          class="mr-2"
          :title="$t('fCustomer_opt_startScoreCurrentTitle')"
        >
          {{ $t('fCustomer_opt_startScoreCurrent') }}: {{ info.start_score.current }}
        </b-badge>
        <div
          v-if="info.start_score.at"
          class="small text-muted text-nowrap"
        >
          {{ $t('fCustomer_opt_startScoreAt') }} {{ info.start_score.at }}
        </div>
      </div>
    </b-list-group-item>
    <b-list-group-item
      v-if="type === 'hostess'"
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="startScoreFloorClass"
    >
      <div class="small text-nowrap">
        {{ $t('fCustomer_opt_startScoreFloor') }}:
      </div>
      <b-form-select
        ref="startScoreFloor"
        v-model="startScoreFloor"
        size="sm"
        style="width: 60px"
        :options="scoreOptions"
        :disabled="isLocked"
        @input="onChange('startScoreFloor')"
      />
    </b-list-group-item>
    <b-list-group-item
      v-if="type === 'hostess'"
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="startScoreLockedClass"
    >
      <div class="small text-nowrap">
        {{ $t('fCustomer_opt_startScoreLocked') }}:
      </div>
      <b-form-checkbox
        v-model="startScoreLocked"
        size="sm"
        switch
        :disabled="isLocked"
        @input="onChange('startScoreLocked')"
      />
    </b-list-group-item>
    <b-list-group-item
      v-if="type === 'hostess'"
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="showAlwaysFeedClass"
    >
      <div
        class="small text-nowrap d-flex align-items-center"
        :class="!showAlwaysFeed ? 'text-danger' : 'text-success'"
        :title="$t('fCustomer_opt_show_always_feed')"
      >
        <span class="mr-2">
          <font-awesome-icon
            v-if="showAlwaysFeed"
            :icon="['fas', 'square-check']"
          />
          <font-awesome-icon v-else :icon="['fas', 'square']" />
        </span>
        <span
          v-shtml="
            showAlwaysFeed
              ? $t('fCustomer_opt_show_always_feed_yes')
              : $t('fCustomer_opt_show_always_feed_no')
          "
        />
      </div>
      <b-form-checkbox
        v-model="showAlwaysFeed"
        size="sm"
        switch
        :disabled="isLocked"
        @input="onChange('showAlwaysFeed')"
      />
    </b-list-group-item>
    <b-list-group-item
      v-if="type === 'hostess'"
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="privacyClass"
    >
      <div class="small text-nowrap">
        {{ $t("fCustomer_opt_privacy") }}:
      </div>
      <span v-if="privacy_locked_by_admin" class="text-danger small">
        {{ $t("fCustomer_opt_privacyLockedByAdmin") }}
      </span>
      <b-form-select
        v-if="formData['privacy']"
        v-model="privacy"
        size="sm"
        :options="formData['privacy']"
        style="width: 100px"
        :disabled="isLocked"
      />
    </b-list-group-item>

    <b-list-group-item
      v-if="type === 'client'"
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="hwFriendClass"
    >
      <div class="small text-nowrap">
        {{ $t("fCustomer_opt_hwFriend") }}:
      </div>
      <b-form-checkbox
        v-model="hw_friend"
        size="sm"
        switch
        @input="onChange('hw_friend')"
      />
    </b-list-group-item>

    <b-list-group-item
      v-if="type === 'client'"
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="isVipClass"
    >
      <div class="small text-nowrap">
        {{ $t("fCustomer_opt_is_vip") }}:
      </div>
      <b-form-checkbox
        v-model="is_vip"
        size="sm"
        switch
        :disabled="isLocked"
        @input="onChange('is_vip')"
      />
    </b-list-group-item>

    <!-- ID-637: view score (quali NEW WING vede il cliente) -->
    <b-list-group-item
      v-if="type === 'client'"
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="viewScoreClass"
    >
      <div class="small text-nowrap">
        {{ $t('fCustomer_opt_viewScore') }}:
      </div>
      <b-form-select
        ref="viewScore"
        v-model="viewScore"
        size="sm"
        style="width: 60px"
        :options="scoreOptions"
        :disabled="isLocked"
        @input="onChange('viewScore')"
      />
    </b-list-group-item>
    <b-list-group-item
      v-if="type === 'client'"
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="viewScoreLockedClass"
    >
      <div class="small text-nowrap">
        {{ $t('fCustomer_opt_viewScoreLocked') }}:
      </div>
      <b-form-checkbox
        v-model="viewScoreLocked"
        size="sm"
        switch
        :disabled="isLocked"
        @input="onChange('viewScoreLocked')"
      />
    </b-list-group-item>

    <b-list-group-item
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="docVerifiedClass"
    >
      <div class="small text-nowrap">
        {{ $t("fCustomer_opt_docVerified") }}:
      </div>
      <b-form-checkbox
        v-model="doc_verified"
        size="sm"
        switch
        :disabled="isLocked"
        @input="onChange('doc_verified')"
      />
    </b-list-group-item>
    <b-list-group-item
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="galleryVerifiedClass"
    >
      <div class="small text-nowrap">
        {{ $t("fCustomer_opt_galleryVerified") }}:
      </div>
      <span v-if="gallery_verified_by_admin" class="text-danger small">
        {{ $t("fCustomer_opt_galleryVerifiedByAdmin") }}
      </span>
      <b-form-checkbox
        v-model="gallery_verified"
        size="sm"
        switch
        :disabled="isLocked"
      />
    </b-list-group-item>
    <b-list-group-item
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="starsClass"
    >
      <div class="small text-nowrap">
        {{ $t("fCustomer_opt_stars") }}:
      </div>
      <span v-if="stars_changed" class="text-danger small">
        {{ $t("fCustomer_opt_starsChanged") }}
      </span>
      <span v-else class="text-muted font-italic small">
        ({{ $t("fCustomer_opt_starsCalculated") }})
      </span>
      <b-form-select
        ref="stars"
        v-model="stars"
        size="sm"
        style="width: 60px"
        :options="starsOptions"
        :disabled="isLocked"
        @input="onChange('stars')"
      />
    </b-list-group-item>
    <b-list-group-item
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="starsFixedClass"
    >
      <div class="small text-nowrap">
        {{ $t("fCustomer_opt_stars_fixed") }}:
      </div>
      <b-form-checkbox
        v-model="stars_fixed"
        size="sm"
        switch
        :disabled="isLocked"
        @input="onChange('stars_fixed')"
      />
    </b-list-group-item>
    <b-list-group-item
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="disablePurchasesClass"
    >
      <div class="small text-nowrap">
        {{ $t("fCustomer_opt_disablePurchases") }}:
      </div>
      <b-form-checkbox
        v-model="disable_purchases"
        size="sm"
        switch
        :disabled="isLocked"
        @input="onChange('disable_purchases')"
      />
    </b-list-group-item>
    <b-list-group-item
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="isSilencedClass"
    >
      <div class="small text-nowrap">
        {{ $t("fCustomer_opt_isSilenced") }}:
      </div>
      <b-form-checkbox
        v-model="isSilenced"
        size="sm"
        switch
        :disabled="isLocked"
        @input="onChange('isSilenced')"
      />
    </b-list-group-item>
    <b-list-group-item
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="whitelistedClass"
    >
      <div class="small text-nowrap">
        {{ $t("fCustomer_opt_whitelisted") }}:
      </div>
      <b-form-checkbox
        v-model="whitelisted"
        size="sm"
        switch
        :disabled="isLocked"
        @input="onChange('whitelisted')"
      />
    </b-list-group-item>
    <b-list-group-item
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="alertMediaClass"
    >
      <div class="small text-nowrap">
        {{ $t("fCustomer_opt_alertMedia") }}:
      </div>
      <b-form-checkbox
        v-model="alert_media"
        size="sm"
        switch
        :disabled="isLocked"
        @input="onChange('alert_media')"
      />
    </b-list-group-item>
    <b-list-group-item
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="checkTaskClass"
    >
      <div class="small text-nowrap">
        {{ $t("fCustomer_opt_checkTask") }}:
        <span
          v-if="check_task_enabled"
          :key="check_task_duration"
          class="text-danger small"
        >
          {{ check_task_duration }} {{ $t("fCustomer_opt_day") }} ({{
            $t("fCustomer_opt_next")
          }}: {{ checkTaskNextAt }})
        </span>
        <span
          v-if="
            !check_task_enabled &&
              (check_task_duration && check_task_duration > 0)
          "
          :key="check_task_duration"
          class="text-danger small"
        >
          ({{
            $t("fCustomer_opt_last")
          }}: {{ checkTaskNextAt }})
        </span>
      </div>
      <div>
        <b-input-group>
          <b-input-group-prepend is-text>
            <input
              v-model="check_task_enabled"
              type="checkbox"
              :disabled="isLocked"
            >
          </b-input-group-prepend>
          <b-form-input
            ref="check_task_duration"
            v-model="check_task_duration"
            :disabled="!check_task_enabled || isLocked"
            type="number"
            size="sm"
            class="text-right"
            style="width: 60px"
            min="0"
            @input="onChange('check_task_duration')"
          />
        </b-input-group>
      </div>
    </b-list-group-item>
    <b-list-group-item
      v-if="type === 'client'"
      class="d-flex flex-row flex-nowrap align-items-center justify-content-between px-2"
      :class="characterDisableCostModifierClass"
    >
      <div
        class="small text-nowrap d-flex align-items-center"
        :class="characterDisableCostModifier ? 'text-danger' : 'text-success'"
        :title="$t('fCustomer_opt_disableCostModifierTitle')"
      >
        <span class="mr-2">
          <font-awesome-icon
            v-if="characterDisableCostModifier"
            :icon="['fas', 'square-check']"
          />
          <font-awesome-icon v-else :icon="['fas', 'square']" />
        </span>
        <span>{{ $t("fCustomer_opt_disableCostModifierTitle") }}&nbsp;</span>
        <span
          v-shtml="
            characterDisableCostModifier
              ? $t('fCustomer_opt_disableCostModifierYes')
              : $t('fCustomer_opt_disableCostModifierNo')
          "
        />
      </div>
      <b-form-checkbox
        v-model="characterDisableCostModifier"
        size="sm"
        switch
        :disabled="isLocked"
        @input="onChange('characterDisableCostModifier')"
      />
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import {
  mapComputedFormFields,
  mapComputedStateFields
} from '~/mixins/globalForm'

export default {
  name: 'OptionsList',
  props: {
    itemId: {
      type: [Number, String],
      required: true
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    repo: {
      type: String,
      required: true,
      default: ''
    },
    idx: {
      type: Number,
      default: -1
    },
    isLocked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // TODO: move that at column's config (ie. `trackCursor: true`)
      trackCursor: [
        'characterMsgCost',
        'characterMsgCostLockedValue',
        'characterStopLoss',
        'characterStopGain',
        'stars',
        'check_task_duration',
        'showAlwaysFeed'
      ]
    }
  },
  computed: {
    ...mapComputedFormFields('customerEdit', [
      'status',
      'showAlwaysFeed',
      'characterMsgCost',
      'characterMsgCostLocked',
      'characterMsgCostLockedValue',
      'characterStopLoss',
      'characterStopGain',
      'characterCostModifier',
      'characterFreeChat',
      'characterDisableCostModifier',
      'privacy',
      'privacy_locked_by_admin',
      'level',
      'stars',
      'stars_fixed',
      'doc_verified',
      'is_vip',
      'gallery_verified',
      'gallery_verified_by_admin',
      'stars_changed',
      'disable_purchases',
      'isSilenced',
      'whitelisted',
      'alert_media',
      'check_task_enabled',
      'check_task_duration',
      'startScore',
      'startScoreFloor',
      'startScoreLocked',
      'viewScore',
      'viewScoreLocked',
      'check_task_created_at',
      'hw_friend'
    ]),
    ...mapComputedStateFields('customerEdit', [
      'dirty',
      'info',
      'type',
      'editColumnName',
      'editColumnCursor'
    ]),
    // ID-637: START SCORE options + row classes
    scoreOptions () {
      return [1, 2, 3, 4, 5, 6].map(v => ({ value: v, text: String(v) }))
    },
    startScoreOptions () {
      return [
        { value: null, text: this.$t('fCustomer_opt_startScoreUnmanaged') },
        ...this.scoreOptions
      ]
    },
    startScoreClass () {
      if (this.isDirty('startScore')) {
        return 'bg-warning'
      }
      return this.startScore !== null && this.startScore !== ''
        ? 'bg-success'
        : ''
    },
    startScoreFloorClass () {
      if (this.isDirty('startScoreFloor')) {
        return 'bg-warning'
      }
      return ''
    },
    // ID-62: dettaglio dell'ultimo blocco del costo (read-only, da info)
    msgCostLockInfo () {
      const lock = this.info?.msg_cost_lock || {}
      return {
        locked: !!lock.locked,
        cost: lock.cost ?? null,
        at: lock.at ?? null,
        by: lock.by ?? null,
        restoreCost: lock.restore_cost ?? null
      }
    },
    characterMsgCostLockedClass () {
      if (this.isDirty('characterMsgCostLocked')) {
        return 'bg-warning'
      }
      return this.characterMsgCostLocked ? 'bg-success' : ''
    },
    startScoreLockedClass () {
      if (this.isDirty('startScoreLocked')) {
        return 'bg-warning'
      }
      return this.startScoreLocked ? 'bg-success' : ''
    },
    viewScoreClass () {
      if (this.isDirty('viewScore')) {
        return 'bg-warning'
      }
      return 'bg-success'
    },
    viewScoreLockedClass () {
      if (this.isDirty('viewScoreLocked')) {
        return 'bg-warning'
      }
      return this.viewScoreLocked ? 'bg-success' : ''
    },
    levelClass () {
      if (this.isDirty('level')) {
        return 'bg-warning'
      }
      return this.level && this.level !== '' ? 'bg-success' : 'bg-danger'
    },
    privacyClass () {
      if (this.isDirty('privacy')) {
        return 'bg-warning'
      }
      return this?.privacy !== '' && this?.privacy >= 0
        ? 'bg-success'
        : 'bg-danger'
    },
    docVerifiedClass () {
      if (this.isDirty('doc_verified')) {
        return 'bg-warning'
      }
      return this.doc_verified && this.doc_verified !== ''
        ? 'bg-success'
        : 'bg-danger'
    },

    starsFixedClass () {
      if (this.isDirty('stars_fixed')) {
        return 'bg-warning'
      }
      return this.stars_fixed && this.stars_fixed !== ''
        ? 'bg-success'
        : 'bg-danger'
    },
    isVipClass () {
      if (this.isDirty('is_vip')) {
        return 'bg-warning'
      }
      return this.is_vip && this.is_vip !== '' ? 'bg-success' : 'bg-danger'
    },
    hwFriendClass () {
      if (this.isDirty('hw_friend')) {
        return 'bg-warning'
      }
      return this.hw_friend && this.hw_friend !== ''
        ? 'bg-success'
        : 'bg-danger'
    },
    galleryVerifiedClass () {
      if (this.isDirty('gallery_verified')) {
        return 'bg-warning'
      }
      return this.gallery_verified && this.gallery_verified !== ''
        ? 'bg-success'
        : 'bg-danger'
    },
    starsOptions () {
      return [0.0, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0].map(v => ({
        value: v,
        text: v % 1 === 0 ? String(v.toFixed(0)) : String(v)
      }))
    },
    starsValid () {
      if (this.isDirty('stars')) {
        const allowed = [0.0, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0]
        return allowed.includes(Number(this.stars))
      }
      return true
    },
    starsClass () {
      if (this.isDirty('stars')) {
        return this.starsValid ? 'bg-warning' : 'bg-danger'
      }
      return this.starsValid ? 'bg-success' : 'bg-danger'
    },
    disablePurchasesClass () {
      if (this.isDirty('disable_purchases')) {
        return 'bg-warning'
      }
      return this.disable_purchases && this.disable_purchases !== ''
        ? 'bg-success'
        : 'bg-danger'
    },
    isSilencedClass () {
      if (this.isDirty('isSilenced')) {
        return 'bg-warning'
      }
      return this.isSilenced && this.isSilenced !== ''
        ? 'bg-success'
        : 'bg-danger'
    },
    whitelistedClass () {
      if (this.isDirty('whitelisted')) {
        return 'bg-warning'
      }
      return this.whitelisted && this.whitelisted !== ''
        ? 'bg-success'
        : 'bg-danger'
    },
    alertMediaClass () {
      if (this.isDirty('alert_media')) {
        return 'bg-warning'
      }
      return this.alert_media && this.alert_media !== ''
        ? 'bg-success'
        : 'bg-danger'
    },
    checkTaskClass () {
      if (
        this.isDirty('check_task_enabled') ||
        this.isDirty('check_task_duration')
      ) {
        return 'bg-warning'
      }
      return this.check_task_enabled &&
        this.check_task_duration &&
        this.check_task_duration !== ''
        ? 'bg-success'
        : 'bg-danger'
    },
    msgCostClass () {
      if (
        this.isDirty('characterMsgCost') ||
        this.isDirty('characterStopLoss') ||
        this.isDirty('characterStopGain')
      ) {
        return parseInt(this.characterMsgCost, 10) >= 3
          ? 'bg-warning'
          : 'bg-danger'
      }
      return parseInt(this.characterMsgCost, 10) >= 3
        ? 'bg-success'
        : 'bg-danger'
    },
    characterFreeChatClass () {
      if (this.isDirty('characterFreeChat')) {
        return 'bg-warning'
      }
      return ''
    },
    showAlwaysFeedClass () {
      if (this.isDirty('showAlwaysFeed')) {
        return 'bg-warning'
      }
      return ''
    },
    characterDisableCostModifierClass () {
      if (this.isDirty('characterDisableCostModifier')) {
        return 'bg-warning'
      }
      return ''
    },
    checkTaskNextAt () {
      const checkTaskCreatedAt =
        this.check_task_created_at || moment().format('YYYY-MM-DD')
      const checkTaskDuration =
        parseInt(this.check_task_duration, 10) >= 0
          ? parseInt(this.check_task_duration, 10)
          : 0
      return moment(checkTaskCreatedAt)
        .add(checkTaskDuration, 'day')
        .format('DD/MM/YY')
    }
  },
  watch: {
    form: {
      handler () {
        this.$forceUpdate()
      },
      deep: true
    }
  },
  mounted () {
    this.setInputState()
  },
  methods: {
    ...mapActions({
      setError: 'setError'
    }),
    setInputState () {
      if (
        this.trackCursor.includes(this.editColumnName) &&
        this.$refs[this.editColumnName]
      ) {
        this.$refs[this.editColumnName].$el.focus()
        if (
          this.$refs[this.editColumnName].$el.setSelectionRange &&
          this.editColumnCursor >= 0
        ) {
          this.$refs[this.editColumnName].$el.setSelectionRange(
            this.editColumnCursor,
            this.editColumnCursor
          )
        }
      }
    },
    onChange (colName) {
      this.editColumnName = colName
      const column = this.$refs[colName]?.$el
      const type = column?.type || ''
      const acceptableTypes = ['text', 'search', 'url', 'tel', 'password']
      if (column && acceptableTypes.includes(type.toLowerCase())) {
        this.editColumnCursor = column.selectionStart || -1
      } else {
        this.editColumnCursor = -1
      }
      this.$nextTick(() => {
        this.setInputState()
      })
    },
    isDirty (fieldKey) {
      const dirtyFields = this.dirty && Object.keys(this.dirty)
      return !!(
        dirtyFields &&
        dirtyFields.length &&
        dirtyFields.includes(fieldKey)
      )
    }
  }
}
</script>

<style scoped></style>
